import { styled } from '@fctg-ds/theme';

const FilterChipContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
}));

export default FilterChipContainer;
